import { useState } from "react";
import { Button } from "@stone-payments/jade";
import { cartAnalitica, productAnalitica } from "@/app/(store)/_utils/events";
import { useOrderResumeStore, useProductStore } from "@/stores";
import {
  AddCartButton,
  CartQuantity,
  CopyShareButton,
  FloatingCartBar,
} from "@/components";
import { useExperiment } from "@/contexts/analitica";
import { ExperimentsFlags } from "@/services/amplitude/experiment";
import { useVitrineStore } from "@/contexts/vitrine-provider";
import { useIsStoreOpen } from "@/hooks/use-is-store-open";

type Props = {
  loading: boolean;
};

export const ProductCartActions = ({ loading }: Props) => {
  const { product, price, stock, chosenVariants, quantity, setQuantity, id } =
    useProductStore();
  const { isOrdersEnabled, store } = useVitrineStore((state) => state);
  const { summary, toggleDrawer, upsertItemFromProduct } =
    useOrderResumeStore();
  const stockExperiment = useExperiment(ExperimentsFlags.Stock);
  const {
    isOpen: isStoreOpen,
    flagOff: isStoreOpenFlagOff,
    flagOn: isStoreOpenFlagOn,
  } = useIsStoreOpen();

  const [showCartBar, setShowCartBar] = useState<boolean>(false);

  const productUrl = `${global.window?.location.origin}/${store.identifier}/produto/${product.id}`;

  const onOpenCart = () => {
    setShowCartBar(false);
    toggleDrawer();
  };

  const addToCart = () => {
    cartAnalitica.events.action.addToCart();

    const variantsArray = Object.values(chosenVariants) || [];

    upsertItemFromProduct({
      id: id || product.variants[0].id,
      productName: product.name,
      productImage: product.images?.[0]?.url,
      price: price!,
      quantity,
      chosenVariants: variantsArray,
    });

    setShowCartBar(true);
    setQuantity(1);
  };

  const onShareLink = () => productAnalitica.events.share.link();

  const disabled =
    stockExperiment.key === "on" &&
    !!store.vitrine.preCheckout.stock?.enabled &&
    stock === 0;

  return (
    <>
      {isOrdersEnabled ? (
        <CartQuantity
          loading={loading}
          price={price}
          quantity={quantity}
          setQuantity={setQuantity}
          disabled={disabled || !isStoreOpen}
        />
      ) : null}

      <div className="flex flex-col gap-jade-50">
        {isOrdersEnabled ? (
          isStoreOpenFlagOff || (isStoreOpenFlagOn && isStoreOpen) ? (
            <AddCartButton
              productName={product.name}
              onAdd={addToCart}
              loading={loading}
              disabled={disabled}
            />
          ) : (
            <Button
              className="w-full"
              variant="neutral-subtle"
              icon="circle-clock"
              disabled
            >
              Loja fechada
            </Button>
          )
        ) : null}

        <CopyShareButton
          loading={loading}
          text={product.name}
          url={productUrl}
          onShare={onShareLink}
          size="large"
        />
      </div>

      <FloatingCartBar
        open={showCartBar}
        quantity={summary.itemsCount}
        price={summary.subtotal}
        onOpenCart={onOpenCart}
      />
    </>
  );
};
